module.exports = __webpack_public_path__ + "img/11.1aa6304b.jpg";